import Axios from 'axios';
var ReportStockService = (function () {
    function ReportStockService() {
    }
    ReportStockService.prototype.getCategory = function (params) {
        return Axios.get('supplierclientapi/suppliergoodstype/category_tree', { params: params });
    };
    ReportStockService.prototype.getStockList = function (params) {
        return Axios.get('supplierclientapi/report/stock_list', { params: params });
    };
    ReportStockService.prototype.getStockDetail = function (params) {
        return Axios.get('supplierclientapi/report/stock_detail', { params: params });
    };
    ReportStockService.prototype.getStockDetailList = function (params) {
        return Axios.get('supplierclientapi/report/stock_io_list', { params: params });
    };
    ReportStockService.prototype.getStockSummaryList = function (params) {
        return Axios.get('supplierclientapi/report/stock_summary', { params: params });
    };
    ReportStockService.createInstance = function () {
        ReportStockService.getInstance();
    };
    ReportStockService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return ReportStockService;
}());
export default ReportStockService;
